import { lazy } from 'react';
import appPage from '../../../hoc/appPage';

const ErrorView = lazy(() => import('../../../views/ErrorView'));

export default appPage(ErrorView, false);
